export class GoogleEcommerce {
    constructor() {
        this.CATEGORY = "Subscription";
        this.BRAND = "WildWorks";
        this.STEPS = {"membershipSelectionStep": 1, "loginStep": 2, "paymentStep": 3, "orderDetailsStep": 4};
        this.pathRegex = {
            "rootCheckout": /(?:\/join)[^\/]*$/i,
            "loginStep": /(?:\/checkout\/\d+)[^\/]*$/i,
            "paymentStep": /(?:\/payment)[^\/]*$/i,
            "orderDetailsStep": /(?:\/order-details)[^\/]*$/i
        };
        this.route();
    }
    route() {
        //calls actions based on the page
        if (this.pathRegex.rootCheckout.test(location.pathname)) {
            this.sendImpressionData();
            this.recordStep(this.STEPS.membershipSelectionStep);
        } else if (this.pathRegex.loginStep.test(location.pathname)) {
            this.recordStep(this.STEPS.loginStep);
        } else if (this.pathRegex.paymentStep.test(location.pathname)) {
            this.recordStep(this.STEPS.paymentStep);
        } else if (this.pathRegex.orderDetailsStep.test(location.pathname)) {
            let data = jQuery(".transactionDetails").data();
            if (this.isAllowedToRecordPurchase(data.paymentMethod)) {
                this.recordStep(this.STEPS.orderDetailsStep)
                this.sendPurchaseData();
            }
        }
    }
    isAllowedToRecordPurchase(paymentMethod) {
        return ["Credit Card", "Credit Card (Worldpay)", "PayPal Account", "Stripe Payments"].includes(paymentMethod)
    }
    sendImpressionData() {
        let list = "Website (join)";
        //set the tracker currency
        let currency = jQuery('.subscriptions-container').data('currency') || 'USD';
        let impressions = [];
        let details = [];
        jQuery('.subscription').each(function (index, sub) {
            jQuery(sub).on('click', function(list) {
                let clickList = list;
                return function (event) {
                    event.preventDefault();
                    let subscription = jQuery(event.currentTarget);
                    let data = subscription.data();
                    let currency = jQuery('.subscriptions-container').data('currency') || 'USD';
                    dataLayer.push({
                        'event': 'productClick',
                        'ecommerce': {
                            'click': {
                                'actionField': {'list': clickList},
                                'products': [{
                                    'id': data.sfSku.toString(),
                                    'name': data.name,
                                    'category': this.CATEGORY,
                                    'position': data.position,
                                    'price': data.price.toString(),
                                    'currency': currency,
                                    'brand': this.BRAND,
                                    'quantity': 1
                                }]
                            }
                        },
                        'eventCallback': function () {
                            document.location = '/checkout/' + data.sfSku;
                        }
                    });
                    dataLayer.push({
                        'event': 'addToCart',
                        'ecommerce': {
                            'currencyCode': currency,
                            'add': {
                                'products': [{
                                    'id': data.sfSku.toString(),
                                    'name': data.name,
                                    'category': this.CATEGORY,
                                    'price': data.price.toString(),
                                    'currency': currency,
                                    'brand': this.BRAND,
                                    'quantity': 1
                                }]
                            }
                        }
                    });
                }
            });
            let subscription = jQuery(sub).data();
            //add dataLayer entry
            impressions.push({
                'id': subscription.sfSku.toString(),
                'name': subscription.name,
                'price': subscription.price.toString(),
                'currency': currency,
                'brand': this.BRAND,
                'category': this.CATEGORY,
                'position': subscription.position,
                'list': list
            });
            details.push({
                'id': subscription.sfSku.toString(),
                'name': subscription.name,
                'price': subscription.price.toString(),
                'brand': this.BRAND,
                'category': this.CATEGORY,
                'currency': currency
            });
        });
        //our site displays subscription impressions and details
        //on a single page
        dataLayer.push({
            'ecommerce': {
                'currencyCode': currency,
                'impressions': impressions,
                'detail': {
                    'products': details
                }
            }
        });
    }
    sendPurchaseData() {
        let data = jQuery(".transactionDetails").data();
        let affiliate = jQuery.cookie("code");
        let actionData = {
            'id': data.transactionId.toString(),
            'revenue': data.price.toString(),
            'step': this.STEPS.orderDetailsStep
        }
        if (affiliate) {
            actionData['affiliation'] = affiliate;
        }
        dataLayer.push({
            'event': 'gtm.dom',
            'ecommerce': {
                'currencyCode': data.currency,
                'purchase': {
                    'actionField': actionData,
                    'products': [
                        {
                            'name': data.name,
                            'id': data.sfSku.toString(),
                            'brand': this.BRAND,
                            'category': this.CATEGORY,
                            'quantity': 1,
                            'price': data.price.toString(),
                            'currency': data.currency
                        }
                    ]
                }
            }
        });
    }
    recordStep(step) {
        dataLayer.push({
            'event': 'checkout',
            'ecommerce': {
                'checkout': {
                    'actionField': {'step': step}
                }
            }
        });
        //setup handlers to set the checkout options
        switch (step) {
            case this.STEPS.loginStep:
                //get the login type (parent or player)
                jQuery("input[type='submit']").off("click.checkoutOption").on("click.checkoutOption", function () {
                    loginRole = jQuery("input[name='auth-method']:checked").val();
                    //prevent a second click event on this step
                    jQuery("input[type='submit']").off("click.checkoutOption");
                    this.onCheckoutOption(step, loginRole);
                });
                break;
            case this.STEPS.paymentStep:
                jQuery("button.primary-button, input[type='submit']").off("click.checkoutOption").on("click.checkoutOption", function () {
                    let paymentMethod = jQuery("input[name='payment-method']:checked").val();
                    this.onCheckoutOption(step, paymentMethod);
                });
                break;
        }
        //get the login type (parent or player)
        let loginRole = jQuery("input[name='auth-method']:checked").val();
    }
    onCheckoutOption(step, checkoutOption) {
        dataLayer.push({
            'event': 'checkoutOption',
            'ecommerce': {
                'checkout_option': {
                    'actionField': {'step': step, 'option': checkoutOption}
                }
            }
        });
    }
    static setup() {
        return new GoogleEcommerce()
    }
}
